import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=70d0de9e"
import script from "./LabelValue.vue?vue&type=script&lang=ts"
export * from "./LabelValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports